
export default {
  components: {},
};
